/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IEspecialty } from 'app/shared/model/especialty.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface ITemplatePrescription {
  id?: string;
  active?: boolean;
  cursor?: number;
  timestampEntry?: number;
  lastUpdated?: number;
  microSec?: number;
  patientType?: keyof typeof PatientType | null;
  templateName?: string;
  forSymptom?: string | null;
  liver?: string | null;
  GFR?: string | null;
  weightMin?: string | null;
  weightMax?: string | null;
  assessment?: string | null;
  diagnosisNotes?: string | null;
  medicationPlan?: string | null;
  owner?: IDoctor;
  hospital?: IHospital | null;
  speciality?: IEspecialty | null;
}

export const defaultValue: Readonly<ITemplatePrescription> = {
  active: false,
};
